import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Card,
  CardContent,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  FormHelperText,
  MenuItem,
} from "@material-ui/core";
import { yupResolver } from "@hookform/resolvers/yup";
import { getProfilePosition } from "../../actions/position-actions";
import * as yup from "yup";
import { getMaestras } from "../../actions/maestras-actions";
import { useStateValue } from "../../context/store";
import { styles } from "../styles";
import { defaultValues } from "./userModels";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import {
  getInfoUserInternal,
  getAllInfoUser,
  getInfoEmployeeInternal,
} from "../../actions/user-actions";
import { ColorButton } from "../../utils/form/buttonsForm";
import { ERROR_MESSAGE, REQUIRED_MESSAGE } from "../../constants";
import FormAutocomplete from "./userAutoComplite";
import EmptyForm from "./emptyForm";
import _ from "lodash";

const UserForm = ({ resetPage, history }) => {
  const classes = styles();
  const [{}, dispatch] = useStateValue();
  //const [validateNumber, setValidateNumber] = useState(false);
  const [autocomplete, setAutocomplete] = useState(false);
  const [typeDocument, setTypeDocument] = useState(false);
  const [disabledInputs, setdisabledInputs] = useState(false);
  const [emptyForm, setEmptyForm] = useState(false);
  const [dataUser, setDataUser] = useState([]);
  const [charges, setCharges] = useState([]);
  const [data, setData] = useState([]);
  const [maestras, setMaestras] = useState({
    generos: [],
    tipoDocumnetoIdentificacion: [],
  });
  const [valuesUser, setValuesUser] = useState({
    document: "",
    type: "",
  });

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    title: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const schema = yup.object().shape({
    type: yup.string().nullable().required(REQUIRED_MESSAGE),
    document: typeDocument
      ? yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 dígitos")
          .max(16, "Ingrese máximo 16 dígitos")
          .matches(
            /^([0-9A-Za-zÑñ]{0,16})$/,
            "Ingrese un número de identificación válido"
          )
      : yup
          .string()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 dígitos")
          .max(16, "Ingrese máximo 16 dígitos")
          .matches(
            /^([0-9]{0,16})$/,
            "Ingrese un número de identificación válido"
          ),
  });

  const {
    register,
    handleSubmit,
    setValue,
    control,
    errors,
    getValues,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues,
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const handleClickClose = async (response) => {
    if (response?.data?.status === "ACTIVO") {
      setDataUser(response);
    }
    setMessage({ ...message, open: false });
    setAutocomplete(true);
  };
  const handleCloseModal = () => setMessage({ ...message, open: false });
  const handleCloseModalWithOutInfoUser = () => {
    //setEmptyForm(true);
    //setMessage({ ...message, open: false });
    history.push("/dashboard/user");
  };
  const handleClickReset = () => {
    setMessage({ ...message, open: false });
    setAutocomplete(false);
    setEmptyForm(false);
  };

  const onSubmit = async (data) => {
    setData(data);
    const response = await getInfoEmployeeInternal(data.document, data.type);
    if (response && response.status >= 200 && response.status <= 399) {
      if (response?.data) {
        setMessage({
          description: `Usuario encontrado`,
          textButtonSubmit: "Aceptar",
          handleClick: () => handleClickClose(response),
          oneButtons: true,
          type: "SUCCESS",
          open: true,
        });
        setdisabledInputs(true);
      } else if (!response?.data) {
        setMessage({
          description: `Para crear el usuario interno, la persona debe contar con un contrato activo.`,
          textButtonSubmit: "ACEPTAR",
          handleClick: () => handleCloseModalWithOutInfoUser(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
        setdisabledInputs(false);
      }
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setMessage({
        description: response.data ? response?.data?.detail : ERROR_MESSAGE,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleCloseModal(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const handleOnchage = (e) => {
    setValue("document", "");
  };

  const valueType = watch("type") === "PP";

  useEffect(() => {
    if (valueType) {
      setTypeDocument(true);
    }
  }, [valueType]);

  useEffect(() => {
    const getListaMaestras = async () => {
      const response = await getMaestras();
      setMaestras(response.data.maestras);
    };
    getListaMaestras();
    const getListCharges = async () => {
      const response = await getProfilePosition("ACTIVO");
      setCharges(
        _.sortBy(response?.data?.chargeList, [
          function (o) {
            return o.denomination;
          },
        ])
      );
    };
    getListCharges();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Crear Usuario interno",
      breadCrumbSubText: "Crear Usuario interno",
      index: 39,
      subPath: "/dashboard/user",
    });
  }, []);

  const handleUserKeyPress = (e) => {
    var form = getValues();
    if (form.type !== "PP") {
      let validChars = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
      if (!validChars.includes(e.key)) {
        e.preventDefault();
      }
    }
  };

  const filterWithoutRCV = maestras?.tipoDocumnetoIdentificacion.filter(
    (x) => x.key !== "RC"
  );
  //const typeOfDocument = watch("type");

  const FormValidate = () => {
    return (
      <React.Fragment>
        <Card elevation={0} style={{ background: "#e0f2f7" }}>
          <CardContent>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                container
                spacing={3}
                alignItems="center"
                style={{ borderRadius: 15, display: "flex" }}
              >
                <Grid item xs={12} md={4} lg={3}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    size="small"
                    error={
                      valuesUser.type === ""
                        ? !!errors.hasOwnProperty("type") &&
                          errors["type"].message
                        : null
                    }
                  >
                    <InputLabel htmlFor="outlined-select-type" shrink={true}>
                      Tipo de documento *
                    </InputLabel>
                    <Controller
                      fullWidth
                      control={control}
                      inputRef={register}
                      disabled={disabledInputs}
                      name="type"
                      size="small"
                      render={(props) => (
                        <Select
                          label="TIPO DE DOCUMENTO *"
                          notched={true}
                          className={classes.dropdown}
                          disabled={disabledInputs}
                          inputProps={{
                            name: "type",
                            id: "outlined-select-type",
                          }}
                          onChange={(e) => {
                            props.onChange(e);
                            handleOnchage(e);
                          }}
                        >
                          <MenuItem value="" disabled>
                            <em>Seleccione</em>
                          </MenuItem>
                          {filterWithoutRCV.map((type) => (
                            <MenuItem
                              className={classes.menuItem}
                              key={type.index}
                              value={type.key}
                            >
                              {type.value}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    />

                    <FormHelperText>
                      {errors.hasOwnProperty("type") && errors["type"].message}
                    </FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={4} lg={3}>
                  <FormControl fullWidth>
                    <TextField
                      InputLabelProps={{ shrink: true }}
                      inputRef={register}
                      type="text"
                      name="document"
                      defaultValue=""
                      disabled={disabledInputs}
                      className={classes.dropdown}
                      placeholder="Número de documento"
                      variant="outlined"
                      fullWidth
                      size="small"
                      label="Número de Documento *"
                      error={
                        errors.hasOwnProperty("document") &&
                        errors["document"].message
                      }
                      onKeyPress={handleUserKeyPress}
                      // helperText={
                      //   errors.hasOwnProperty("document") &&
                      //   errors["document"].message
                      // }
                    />
                  </FormControl>
                  <FormHelperText style={{ color: "#f44336" }}>
                    {errors.hasOwnProperty("document") &&
                      errors["document"].message}
                  </FormHelperText>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                  &nbsp;&nbsp;
                  <ColorButton
                    type="submit"
                    disabled={
                      watch("document") === "" || emptyForm || autocomplete
                    }
                    style={{
                      background: watch("document") === "" ? "gray" : null,
                    }}
                    className={classes.create}
                  >
                    CONTINUAR
                  </ColorButton>
                </Grid>
              </Grid>
            </form>
          </CardContent>
          {validateFormInitial()}
        </Card>
        <ModalConfirm
          description={message.description}
          textButtonSubmit={message.textButtonSubmit}
          handleClick={message.handleClick}
          handleClickOut={message.handleClickOut}
          oneButtons={message.oneButtons}
          title={message.title}
          type={message.type}
          open={message.open}
        />
      </React.Fragment>
    );
  };

  const validateFormInitial = () => {
    if (emptyForm)
      return (
        <EmptyForm
          dataUser={dataUser}
          charges={[...charges]}
          message={message}
          setMessage={setMessage}
          handleClickReset={handleClickReset}
          dataInserted={data}
        />
      );
    else if (autocomplete)
      return (
        <FormAutocomplete
          dataUser={dataUser}
          charges={[...charges]}
          message={message}
          setMessage={setMessage}
          resetPage={resetPage}
          handleClickReset={handleClickReset}
        />
      );
    // else return FormValidate();
  };

  return <React.Fragment>{FormValidate()}</React.Fragment>;
};

export default UserForm;
